import React from "react";
import Container from "../components/Layouts/Container";
import HomeBanner from "../components/Home/HomeBanner";
import HowItWorks from "../components/Home/HowItWorks";
import BestServices from "../components/Home/BestServices";
import HomeAboutUs from "../components/Home/HomeAboutUs";
import Testimonials from "../components/Home/Testimonials";
import LastDetailsSection from "../components/Home/LastDetailsSection";
import { HomeContact } from "../components/Home/HomeContact";
import FreQuestion from "../components/Home/FreQuestion";
import { getLabelDetailList } from "../store/Slice/labelDetailSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getServicesDetailList } from "../store/Slice/servicesDetailSlice";

const HomePage = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { labelDetailData } = useSelector((state) => state.labelDetailList);

  const { servicesDetailData, loading } = useSelector(
    (state) => state.servicesDetailList
  );

  const path = React.useMemo(() => {
    return location.pathname === "/" ? "home" : location.pathname.slice(1);
  }, [location.pathname]);

  // const scrollToForm = () => {
  //   if (formRef.current) {
  //     setTimeout(() => {
  //       formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }, 1000);
  //   }
  // };

  // React.useEffect(() => {
  //   if (sessionStorage.getItem("scrollToForm")) {
  //     scrollToForm();
  //     sessionStorage.removeItem("scrollToForm"); // Remove after use
  //     window.history.replaceState({}, document.title);
  //   }
  // }, []);

  React.useEffect(() => {
    dispatch(getServicesDetailList());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getLabelDetailList({ vSlug: path }));
  }, [dispatch, path]);

  return (
    <>
      <Container>
        <HomeBanner />
        <HowItWorks />
        <HomeContact
          labelDetailData={labelDetailData}
          servicesDetailData={servicesDetailData}
        />
        <BestServices
          labelDetailData={labelDetailData}
          servicesDetailData={servicesDetailData}
          loading={loading}
        />
        <HomeAboutUs labelDetailData={labelDetailData} />
        <Testimonials labelDetailData={labelDetailData} />
        <FreQuestion labelDetailData={labelDetailData} />
        <LastDetailsSection labelDetailData={labelDetailData} />
      </Container>
    </>
  );
};

export default HomePage;
